import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[shEscapeDialog]',
    standalone: true
})
export class EscapeDialogDirective {
    @Output() shEscapePressed: EventEmitter<void> = new EventEmitter();

    constructor(private readonly elementRef: ElementRef) {}

    @HostListener('document:keydown', ['$event'])
    handleEscapePress(keyboardEvent: KeyboardEvent): void {
        const allDialogs: HTMLCollectionOf<HTMLDialogElement> = document.getElementsByTagName('dialog');
        const upperDialog: HTMLDialogElement = allDialogs[allDialogs.length - 1];
        const isUpperMostDialog: boolean = upperDialog === this.elementRef.nativeElement;

        if (keyboardEvent.key === 'Escape' && isUpperMostDialog) {
            this.shEscapePressed.emit();
        }
    }
}
